module.exports = __webpack_public_path__ + "static/dhampur-green-17a86b95712d69c5419546617557d30a.png";